






import Vue, { PropType } from "vue";

export interface Data {}
export interface Computed {}
export interface Methods {}
export interface Props {
  size: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "LoadingIcon",
  props: {
    size: {
      type: String as PropType<Props["size"]>,
      default: "40"
    }
  }
});
